var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Box, Divider, Grid, styled, Tab, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDeclinedJobCountURL } from "../../../api/url";
import { NoDocumentsIcon } from "../../../assets/customIcons";
import { MuiButton, MuiStack } from "../../../components";
import SkeletonLoader from "../../../components/atoms/sketeton";
import { createAPI, setState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { faintblue, faintGray, gray, lightGray } from "../../../theme/palette";
import DeclinedAdditionalJobsComponent from "./previouslyDeclinedJobs/DeclinedAdditionalJobsComponent";
import DeclinedCustomerComplaint from "./previouslyDeclinedJobs/DeclinedCustomerComplaintComponent";
import DeclinedPMJobs from "./previouslyDeclinedJobs/DeclinedPeriodicMaintenanceComponent";
import DeclinedStandardJobs from "./previouslyDeclinedJobs/DeclinedStandardJobsComponent";
import { ESystemName } from "../../../constants";
var CustomTabList = styled(TabList)({
    borderRadius: "8px",
    background: lightGray,
    border: "1px solid ".concat(faintGray),
    minHeight: "40px",
    display: "flex",
    "& .MuiTabs-indicator": {
        display: "none"
    },
    "& .MuiTabs-flexContainer": {
        padding: "3px"
    },
    "& .MuiTabs-scrollButtons.Mui-disabled": {
        opacity: 0.3
    }
});
var CustomTab = styled(Tab)({
    textTransform: "capitalize",
    fontWeight: 600,
    fontSize: "14px",
    padding: "8px 9px",
    minHeight: "35px",
    borderRadius: "8px",
    color: "#8593A3",
    "&.Mui-selected": {
        color: "#000",
        backgroundColor: "#fff",
        boxShadow: "0px 1px 3px 0px #1018281A"
    }
});
var PreviousDeclinedJob = function (props) {
    var _previousJobCards$dat7, _previousJobCards$dat8, _previousJobCards$dat9, _moment, _formData$Organizatio, _formData$Organizatio2, _formData$Organizatio3, _formData$Organizatio4, _formData$Organizatio5, _formData$Organizatio6, _formData$Organizatio7, _formData$Organizatio8, _formData$Organizatio9, _formData$Organizatio10, _declinedJobsCount$da, _declinedJobsCount$da2, _declinedJobsCount$da3, _declinedJobsCount$da4, _declinedJobsCount$da5, _declinedJobsCount$da6, _declinedJobsCount$da7, _declinedJobsCount$da8;
    var closePopup = props.closePopup, ModuleDetailsGetById = props.ModuleDetailsGetById, previousJobCards = props.previousJobCards, ModuleName = props.ModuleName, ModuleSectionByChannel = props.ModuleSectionByChannel, disabledPreviousDeclined = props.disabledPreviousDeclined, getSavedPeriodicPartsUrl = props.getSavedPeriodicPartsUrl;
    var dispatch = useAppDispatch();
    var _a = useParams(), estimateId = _a.estimateId, appointmentId = _a.appointmentId, inspectionId = _a.inspectionId;
    var _b = useState(), value = _b[0], setValue = _b[1];
    var _c = useState(), formData = _c[0], setFormData = _c[1];
    var _d = useState(true), showTab = _d[0], setShowTab = _d[1];
    var _e = useState(false), showGroupItem = _e[0], setShowGroupItem = _e[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _f = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; }), declinedJobsCount = _f.declinedJobsCount, isLoadingPreviousJobCards = _f.isLoadingPreviousJobCards;
    useEffect(function () {
        var _previousJobCards$dat, _previousJobCards$dat2, _previousJobCards$dat3, _previousJobCards$dat4;
        dispatch(setState({
            key: "isLoadingPreviousJobCards",
            value: true
        }));
        if ((previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat = previousJobCards.data) === null || _previousJobCards$dat === void 0 ? void 0 : _previousJobCards$dat.length) === 1) {
            setShowTab(false);
        }
        setValue(previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat2 = previousJobCards.data[0]) === null || _previousJobCards$dat2 === void 0 ? void 0 : _previousJobCards$dat2.id);
        setFormData(previousJobCards === null || previousJobCards === void 0 ? void 0 : previousJobCards.data[0]);
        if (previousJobCards !== null && previousJobCards !== void 0 && previousJobCards.data && (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat3 = previousJobCards.data) === null || _previousJobCards$dat3 === void 0 ? void 0 : _previousJobCards$dat3.length) > 0 && previousJobCards !== null && previousJobCards !== void 0 && (_previousJobCards$dat4 = previousJobCards.data[0]) !== null && _previousJobCards$dat4 !== void 0 && _previousJobCards$dat4.id) {
            var _previousJobCards$dat5;
            declinedJobCountAPI(previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat5 = previousJobCards.data[0]) === null || _previousJobCards$dat5 === void 0 ? void 0 : _previousJobCards$dat5.id);
        }
        dispatch(setState({
            key: "isLoadingPreviousJobCards",
            value: false
        }));
    }, [previousJobCards === null || previousJobCards === void 0 ? void 0 : previousJobCards.data]);
    useEffect(function () {
        if ((ModuleSectionByChannel === null || ModuleSectionByChannel === void 0 ? void 0 : ModuleSectionByChannel.length) > 0) {
            var _showGroupItem = ModuleSectionByChannel === null || ModuleSectionByChannel === void 0 ? void 0 : ModuleSectionByChannel.find(function (i) { return (i === null || i === void 0 ? void 0 : i.Key) === "PREVIOUS_DECLINED_JOBS"; });
            setShowGroupItem(_showGroupItem === null || _showGroupItem === void 0 ? void 0 : _showGroupItem.ShowGroupItems);
        }
    }, [(ModuleSectionByChannel === null || ModuleSectionByChannel === void 0 ? void 0 : ModuleSectionByChannel.length) > 0]);
    var handleChange = function (event, newValue) {
        var _previousJobCards$dat6;
        setValue(newValue);
        var data = previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat6 = previousJobCards.data) === null || _previousJobCards$dat6 === void 0 ? void 0 : _previousJobCards$dat6.find(function (item) { return item.id === newValue; });
        setFormData(data);
        declinedJobCountAPI(data.id);
    };
    var declinedJobCountAPI = function (jobCardId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(createAPI({
                        key: "declinedJobsCount",
                        url: getDeclinedJobCountURL,
                        request: {
                            ParentId: jobCardId,
                            Entity: ModuleName === ESystemName.ServiceEstimate ? ESystemName.Estimate : ModuleName
                        }
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var tabCount = (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat7 = previousJobCards.data) === null || _previousJobCards$dat7 === void 0 ? void 0 : _previousJobCards$dat7.length) || 0;
    return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, isLoadingPreviousJobCards && !(previousJobCards !== null && previousJobCards !== void 0 && previousJobCards.data) ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '90vw',
            height: '19vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '90vw',
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '90vw',
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '90vw',
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isLoadingPreviousJobCards && previousJobCards && (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat8 = previousJobCards.data) === null || _previousJobCards$dat8 === void 0 ? void 0 : _previousJobCards$dat8.length) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, showTab && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(TabContext, {
        value: value
    }, /*#__PURE__*/ React.createElement(CustomTabList, {
        variant: "scrollable",
        scrollButtons: "auto",
        allowScrollButtonsMobile: true,
        onChange: handleChange
    }, previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat9 = previousJobCards.data) === null || _previousJobCards$dat9 === void 0 ? void 0 : _previousJobCards$dat9.map(function (item, index) { /*#__PURE__*/ return React.createElement(CustomTab, {
        key: index,
        label: /*#__PURE__*/ React.createElement(Typography, {
            variant: "h5",
            align: "center"
        }, "Job Card #".concat(index + 1)),
        value: item === null || item === void 0 ? void 0 : item.id,
        sx: {
            flexBasis: "".concat(100 / tabCount, "%"),
            maxWidth: "".concat(100 / tabCount, "%")
        }
    }); })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            backgroundColor: faintblue,
            borderRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        columnSpacing: 3
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: "gray"
    }, t("DOC NO"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "DocNo",
        variant: "h6"
    }, formData === null || formData === void 0 ? void 0 : formData.SourceDocumentNo)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: "gray"
    }, t("DATE"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "DocDate",
        variant: "h6"
    }, (_moment = moment(formData === null || formData === void 0 ? void 0 : formData.JobCardDate)) === null || _moment === void 0 ? void 0 : _moment.format("DD MMM, YYYY"))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: "gray"
    }, t("SA"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "ServiceAdvisorName",
        variant: "h6"
    }, "".concat(formData === null || formData === void 0 ? void 0 : formData.ServiceAdvisorGivenName, " ").concat(formData === null || formData === void 0 ? void 0 : formData.ServiceAdvisorFamilyName)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: gray
    }, t("Dealer"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "OrganizationAddress",
        variant: "h6"
    }, "".concat(formData === null || formData === void 0 ? void 0 : formData.OrganizationName), " ", "".concat(formData !== null && formData !== void 0 && (_formData$Organizatio = formData.OrganizationAddress) !== null && _formData$Organizatio !== void 0 && _formData$Organizatio.CityName ? '-' : ""), " ", "".concat(formData !== null && formData !== void 0 && (_formData$Organizatio2 = formData.OrganizationAddress) !== null && _formData$Organizatio2 !== void 0 && _formData$Organizatio2.CityName ? formData === null || formData === void 0 || (_formData$Organizatio3 = formData.OrganizationAddress) === null || _formData$Organizatio3 === void 0 ? void 0 : _formData$Organizatio3.CityName : ""))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "Org-Address-State-City",
        variant: "subtitle1",
        fontWeight: 400,
        color: gray
    }, "".concat(formData !== null && formData !== void 0 && (_formData$Organizatio4 = formData.OrganizationAddress) !== null && _formData$Organizatio4 !== void 0 && _formData$Organizatio4.CityName ? formData === null || formData === void 0 || (_formData$Organizatio5 = formData.OrganizationAddress) === null || _formData$Organizatio5 === void 0 ? void 0 : _formData$Organizatio5.CityName : "", " \n                        ").concat(formData !== null && formData !== void 0 && (_formData$Organizatio6 = formData.OrganizationAddress) !== null && _formData$Organizatio6 !== void 0 && _formData$Organizatio6.CityName ? ',' : "", "\n                        ").concat(formData !== null && formData !== void 0 && (_formData$Organizatio7 = formData.OrganizationAddress) !== null && _formData$Organizatio7 !== void 0 && _formData$Organizatio7.StateName ? formData === null || formData === void 0 || (_formData$Organizatio8 = formData.OrganizationAddress) === null || _formData$Organizatio8 === void 0 ? void 0 : _formData$Organizatio8.StateName : "", "\n                        ").concat(formData !== null && formData !== void 0 && (_formData$Organizatio9 = formData.OrganizationAddress) !== null && _formData$Organizatio9 !== void 0 && _formData$Organizatio9.Zip ? formData === null || formData === void 0 || (_formData$Organizatio10 = formData.OrganizationAddress) === null || _formData$Organizatio10 === void 0 ? void 0 : _formData$Organizatio10.Zip : ""))))))), (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da = declinedJobsCount.data) === null || _declinedJobsCount$da === void 0 ? void 0 : _declinedJobsCount$da.PeriodicParts) > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(DeclinedPMJobs, {
        parentModuleName: ModuleName,
        jobCount: (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da2 = declinedJobsCount.data) === null || _declinedJobsCount$da2 === void 0 ? void 0 : _declinedJobsCount$da2.PeriodicParts) || 0,
        jobCardID: formData === null || formData === void 0 ? void 0 : formData.id,
        currentJobCardData: ModuleDetailsGetById,
        disabledPreviousDeclined: disabledPreviousDeclined,
        getSavedPeriodicPartsUrl: getSavedPeriodicPartsUrl
    })), (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da3 = declinedJobsCount.data) === null || _declinedJobsCount$da3 === void 0 ? void 0 : _declinedJobsCount$da3.StandardJobs) > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(DeclinedStandardJobs, {
        showGroupItems: showGroupItem,
        parentModuleName: ModuleName,
        jobCount: (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da4 = declinedJobsCount.data) === null || _declinedJobsCount$da4 === void 0 ? void 0 : _declinedJobsCount$da4.StandardJobs) || 0,
        jobCardID: formData === null || formData === void 0 ? void 0 : formData.id,
        currentJobCardData: ModuleDetailsGetById,
        disabledPreviousDeclined: disabledPreviousDeclined,
        getSavedStandaredJobUrl: props.getSavedStandaredJobUrl
    })), (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da5 = declinedJobsCount.data) === null || _declinedJobsCount$da5 === void 0 ? void 0 : _declinedJobsCount$da5.AdditionalJobs) > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(DeclinedAdditionalJobsComponent, {
        parentModuleName: ModuleName,
        jobCount: (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da6 = declinedJobsCount.data) === null || _declinedJobsCount$da6 === void 0 ? void 0 : _declinedJobsCount$da6.AdditionalJobs) || 0,
        jobCardID: formData === null || formData === void 0 ? void 0 : formData.id,
        currentJobCardData: ModuleDetailsGetById,
        disabledPreviousDeclined: disabledPreviousDeclined
    })), (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da7 = declinedJobsCount.data) === null || _declinedJobsCount$da7 === void 0 ? void 0 : _declinedJobsCount$da7.CustomerComplaints) > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(DeclinedCustomerComplaint, {
        showGroupItems: showGroupItem,
        parentModuleName: ModuleName,
        jobCount: (declinedJobsCount === null || declinedJobsCount === void 0 || (_declinedJobsCount$da8 = declinedJobsCount.data) === null || _declinedJobsCount$da8 === void 0 ? void 0 : _declinedJobsCount$da8.CustomerComplaints) || 0,
        jobCardID: formData === null || formData === void 0 ? void 0 : formData.id,
        currentJobCardData: ModuleDetailsGetById,
        disabledPreviousDeclined: disabledPreviousDeclined
    }))) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            textAlign: 'center'
        }
    }, /*#__PURE__*/ React.createElement(NoDocumentsIcon, {
        sx: {
            width: '250px',
            height: '200px'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "no-records-message",
        variant: "h2",
        sx: {
            fontWeight: '600'
        }
    }, "No records found "), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: '#6A7682'
    }, "There is no any data available for previously declined jobs")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            marginLeft: -3,
            marginRight: -3
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancel-prev-button",
        variant: "text",
        name: t("Cancel"),
        onClick: function () { return closePopup(false); }
    }))));
};
export default PreviousDeclinedJob;
